import styled from '@emotion/styled';

const EmptyIcon = styled('img')({
  height: '9.1rem',
  width: '12rem',
});

export default EmptyIcon;
